export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/toJSON.js
// module id = 399
// module chunks = 0